/**
 * @deprecated This file should no longer be used.
 */
const colors = {
    snuff: '#DEDDEC',
    astronaut: '#2b32b2',
    governorBay: '#2A36AB',
    mariner: '#1b1e63',
    selago: '#edf2fc',
    grandis: '#ffd28d',
    visVis: '#FFF3A5',
    sushi: '#71b543',
    orangePeel: '#ffa100',
    orange: '#F2994A',
    monza: '#d9031b',
    silver: '#BDBDBD',
    boulder: '#797979',
    doveGrey: '#666666',
    brightGray: '#383E45',
    mineShaft: '#333333',
    cherub: '#fae2e5',
    pippin: '#FFE2DF',
    frenchRose: '#EF476F',
    scarlett: '#8f0011',
    pomegranate: '#F44336',
    hintOfGreen: '#e8ffe6',
    hummingBird: '#CCF9E4',
    jungleGreen: '#27AE60',
    japaneseLaurel: '#086a00',
    islandSpice: '#fff9ed',
    saddleBrown: '#4d2f00',
    dodgerBlue: '#577FFE',
    hawkesBlue: '#E1E8FD',
    iron: '#CACCCF',
    gallery: '#EEEEEE',
    black: '#000000',
    wildSand: '#F6F6F6',
    caribbeanGreen: '#06D6A0',
    concrete: '#D2D1CD',
}
export type ThemeColorKey = keyof typeof colors
/**
 * @deprecated This file should no longer be used. Please use ThemeProvider theme to access lineHeight
 */
const lineHeight = {
    xs: '16px',
    s: '18px',
    m: '20px',
    l: '24px',
    xl: '28px',
    xxl: '30px',
    xxxl: '44px',
    xxxxl: '48px',
} as const
/**
 * @deprecated This file should no longer be used. Please use ThemeProvider theme to access colors. Only use this if the design is not using semantic colors
 */
const newColors = {
    primary500: '#253778',
    primary400: '#005BA7',
    primary300: '#008BFF',
    primary200: '#74C0FF',
    primary100: '#E8F5FC',
    primary50: '#F3FAFD',
    secondary500: '#AA3815',
    secondary400: '#D1603D',
    secondary300: '#EC6E47',
    secondary200: '#F9A51A',
    secondary100: '#FFD871',
    alertError300: '#AF061A',
    alertError200: '#F0102B',
    alertError100: '#FFE3E5',
    alertWarning300: '#BF570C',
    alertWarning200: '#F16D0D',
    alertWarning100: '#FFE5D1',
    alertSuccess300: '#07775C',
    alertSuccess200: '#0AA781',
    alertSuccess100: '#DFF6F1',
    neutral700: '#37383A',
    neutral600: '#4A4A4A',
    neutral500: '#737373',
    neutral400: '#ADADAD',
    neutral300: '#C8C7CC',
    neutral200: '#E0E0E0',
    neutral100: '#F2F2F2',
    neutral50: '#FFFFFF',
} as const
/**
 * @deprecated This file should no longer be used. Please use ThemeProvider theme to access fontSize
 */
const newFontSizes = {
    xxs: '10px',
    xs: '12px',
    s: '14px',
    m: '16px',
    l: '18px',
    xl: '20px',
    xxl: '24px',
    xxxl: '36px',
    xxxxl: '48px',
} as const
/**
 * @deprecated This file should no longer be used. Please use ThemeProvider theme to access spacing
 */
const spacing = {
    xxxxs: '0.187rem',
    xxxs: '0.375rem',
    xxs: '0.75rem',
    xs: '1.5rem',
    s: '2rem',
    m: '3rem',
    l: '4rem',
    xl: '6rem',
} as const
/**
 * @deprecated This file should no longer be used. Please use ThemeProvider theme to access spacing
 */
const newSpacing = {
    xxxxs: '4px',
    xxxs: '6px',
    xxs: '8px',
    xs: '10px',
    s: '12px',
    m: '16px',
    l: '24px',
    xl: '32px',
    xxl: '36px',
    xxxl: '48px',
    xxxxl: '60px',
} as const
/**
 * @deprecated This file should no longer be used.
 */
const gutter = {
    xs: '1rem',
    s: '1.5rem',
}
/**
 * @deprecated This file should no longer be used. Please use ThemeProvider theme to access fontSize
 */
const fontWeight = {
    regular: 400,
    medium: 500,
    bold: 700,
} as const

/**
 * @deprecated This file should no longer be used. Please use ThemeProvider theme to access boxShadow
 */
const boxShadow = {
    level1: '0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
    level2: '0px 1px 8px 0px rgba(0, 0, 0, 0.06)',
    level3: '0px 0px 12px 0px rgba(0, 0, 0, 0.12)',
    level2Right: '2px 0px 8px 0px rgba(0, 0, 0, 0.06)',
} as const

/**
 * @deprecated This file should no longer be used. Please use ThemeProvider theme to access fontSize
 */
const oldFontSizes = [12, 14, 16, 18, 20, 24, 32, 48, 64, 72]

/**
 * @deprecated This file should no longer be used. Please use ThemeProvider theme to access fontSize
 */
export const theme = {
    colors,
    spacing,
    newSpacing,
    gutter,
    newFontSizes,
    fontWeight,
    lineHeight,
    newColors,
    fontSizes: oldFontSizes,
    boxShadow,
}
